export default {"src":"/_next/static/media/ics24-logo-primary.5f23722d.svg","height":40,"width":240,"blurWidth":0,"blurHeight":0};